/**
 * Created by iAlex on 15/03/16.
 */

/**
 *
 * Main class
 *
 */

var Main = new (function (){

    var that = this;
    /**
     * Init
     */
    this.init = function() {
        $('#close-gral-menu').on('click', that.closeGralMenu);
        $('#close-regional-menu').on('click', that.closeRegionalMenu);
        $('#select-region-btn').on('click', that.autoOpenSubmenu);
    }; //init

    /**
     * closeGralMenu
     */
    this.closeGralMenu = function() {
        $('#gral-nav .navbar-toggle').trigger('click');
    }; //closeGralMenu

    /**
     * closeRegionalMenu
     */
    this.closeRegionalMenu = function() {
        $('#select-region-btn').trigger('click');
    }; //closeRegionalMenu

    /**
     * autoOpenSubmenu
     */
    this.autoOpenSubmenu = function() {
        if($('#gral-menu').hasClass('collapse in')) {
            $('#gral-nav .navbar-toggle').trigger('click');
        }
        setTimeout(function() {
            $('#regional-menu .navbar-nav .central-america').addClass('open');
        }, 2500);
    }; //autoOpenSubmenu

})();

$(window).scroll( function (e) {

});

$( window ).resize(function() {

});